var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('images-gallery',{ref:"imagesGallery",attrs:{"shouldCloseOnSwipe":_vm.shouldCloseOnSwipe},on:{"currentIndexChange":_vm.currentIndexChangeHandler,"galleryClose":_vm.galleryCloseHandler,"galleryClosed":_vm.onGalleryClosedHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }